module.exports = __webpack_public_path__ + "media/contact/line2-d6fe46e2.png";